import { createTheme } from '@mui/material/styles'
import { orange, blue, red, green } from '@mui/material/colors'

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string
    }
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string
    }
  }
}

const theme = createTheme({
  palette: {
    mode: 'light', // dark
    primary: {
      main: blue['600'],
    },
    secondary: {
      main: red['600'],
    },
    success: {
      main: green['600'],
    },
  },
  status: {
    danger: orange[500],
  },
})

export default theme
